import { AgentIntent } from "./types";

export interface IntentChoice {
  intent: AgentIntent;
  /** False while the agent answers that intent with a stub; shown but not offered. */
  isAvailable: boolean;
}

/**
 * The choices offered when the agent could not tell an edit from a question,
 * in display order. Copy lives in the `pogAgent` locale under `picker.<intent>`
 * and `intent.<intent>`. Diagnose stays visible so the vocabulary is complete,
 * but it is disabled until the agent implements it — today it answers "not
 * implemented yet".
 */
export const INTENT_CHOICES: IntentChoice[] = [
  { intent: "postprocess", isAvailable: true },
  { intent: "qa", isAvailable: true },
  { intent: "diagnose", isAvailable: false },
];
